// extracted by mini-css-extract-plugin
module.exports = {"image":"FullScreenImage-module--image--RJ7Qk"};